import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mohprjgkvmnxfqssiggw.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_cJqteFw2WLbBUh_ILHF3qA_fRahmb0I';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Número administrador — siempre tiene acceso completo
export const ADMIN_PHONE = '526675680042';
